import {
  defaultSettings,
} from '@components/Widgets/_contentItems/_baseTemplate'

export const defaultStyling = {
  padding: '20px',
  color: 'rgba(0, 0, 0, 0)',
}

export default {
  id: '64534345',
  type: 'spacer',
  category: 'other',
  content: {},
  settings: {
    ...defaultSettings,
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: { ...defaultStyling },
}
